function Tunisia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2344)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#D80027"/>
  <path d="M16 23.652C20.2262 23.652 23.6522 20.226 23.6522 15.9998C23.6522 11.7737 20.2262 8.34766 16 8.34766C11.7738 8.34766 8.34778 11.7737 8.34778 15.9998C8.34778 20.226 11.7738 23.652 16 23.652Z" fill="#F0F0F0"/>
  <path d="M16.9427 13.0742L18.2554 14.8833L20.3815 14.1939L19.0667 16.0014L20.3793 17.8104L18.2539 17.1184L16.9391 18.9259L16.9405 16.6908L14.8152 15.9988L16.9413 15.3095L16.9427 13.0742Z" fill="#D80027"/>
  <path d="M17.7391 20.5216C15.2419 20.5216 13.2174 18.4971 13.2174 15.9998C13.2174 13.5026 15.2419 11.4781 17.7391 11.4781C18.5178 11.4781 19.2504 11.6749 19.8901 12.0216C18.8866 11.0403 17.5144 10.4346 16 10.4346C12.9265 10.4346 10.4348 12.9262 10.4348 15.9998C10.4348 19.0733 12.9265 21.5649 16 21.5649C17.5144 21.5649 18.8867 20.9593 19.8901 19.9779C19.2504 20.3247 18.5178 20.5216 17.7391 20.5216Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Tunisia;
